import axios from "axios";
import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { parseJwt, setOrgLocalUserData } from "../../common/utils/Functions";
import ReactLoader from "../../components/reactLoader/ReactLoader";

const RedirectAsAdminPage = () => {
  const navigate = useNavigate();
  const { token } = useParams();

  useEffect(() => {
    if (!token) return;

    const data = parseJwt(token);
    setOrgLocalUserData(data?.uuid, token);

    axios
      .get(`${process.env.REACT_APP_BASE_URL}dashboard/count`, {
        headers: {
          Authorization: token,
          secretkey: process.env.REACT_APP_SECRET_KEY,
        },
      })
      .then((res) => {
        const totalTips = res.data?.data?.totalTips ?? 0;
        localStorage.setItem("total_tips", String(totalTips));
        if (totalTips === 0) {
          navigate(`/${data?.uuid}/QR-Codes-&-links`);
        } else {
          navigate(`/${data?.uuid}/dashboard`);
        }
      })
      .catch(() => {
        navigate(`/${data?.uuid}/dashboard`);
      });
  }, [token]);

  return <ReactLoader />;
};

export default RedirectAsAdminPage;
